module.exports = __webpack_public_path__ + "files/dadb8c7ec98ae82cc8ff9b5fdf3d4605.png";